import { Composite, Spec } from 'spec-pattern';
import ActBillingContext from '../optimisation/ActBillingContext';

export abstract class ActOptimisationSpecification
  extends Composite<ActBillingContext, unknown>
  implements Spec<ActBillingContext, unknown> {}
